<fieldset [disabled]="editable">
	<mat-table
		#dataTable
		*ngIf="data.locationOptionalTrips"
		[dataSource]="data.locationOptionalTrips"
		cdkDropList
		(cdkDropListDropped)="dropTable($event)"
		matTooltip="Aby dodać wycieczke fakultatyną do lokalizacji przejdź do ustawień wycieczek fakultatywnych"
	>
		<ng-container matColumnDef="name">
			<mat-header-cell *matHeaderCellDef> Nazwa </mat-header-cell>
			<mat-cell *matCellDef="let element">{{ element.optionalTrip.name }}</mat-cell>
		</ng-container>

		<ng-container matColumnDef="description">
			<mat-header-cell *matHeaderCellDef> Opis </mat-header-cell>
			<mat-cell *matCellDef="let element">{{ element.optionalTrip.description }}</mat-cell>
		</ng-container>

		<ng-container matColumnDef="isActive">
			<mat-header-cell *matHeaderCellDef> Aktywna </mat-header-cell>
			<mat-cell *matCellDef="let element">{{ element.optionalTrip.isActive }}</mat-cell>
		</ng-container>

		<ng-container matColumnDef="edit">
			<mat-header-cell *matHeaderCellDef></mat-header-cell>
			<mat-cell *matCellDef="let element">
				<div
					[matTooltipDisabled]="!editable"
					matTooltip="Przycisk aktywny po zapisaniu zmian"
					[matTooltipPosition]="'right'"
				>
					<button
						mat-raised-button
						color="primary"
						class="me-3"
						[disabled]="editable"
						(click)="editOptionalTrip(element)"
					>
						Edytuj
						<i class="fas fa-angle-double-right"></i>
					</button></div
			></mat-cell>
		</ng-container>

		<mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
		<mat-row *matRowDef="let row; columns: displayedColumns" cdkDrag></mat-row>
	</mat-table>
	<div *ngIf="!data.locationOptionalTrips?.length" class="alert mt-4 alert-warning text-center">
		Żadna wycieczka fakultatywna nie jest przypisana do tej lokalizacji
	</div>
	<div class="d-flex justify-content-end my-4">
		<div [matTooltipDisabled]="!editable" matTooltip="Przycisk aktywny po zapisaniu zmian">
			<button [disabled]="editable" mat-raised-button color="primary" class="btn me-3">
				<a
					[className]="editable ? 'text-muted text-decoration-none' : 'text-white text-decoration-none'"
					routerLink="/optionalTrip"
				>
					Ustawienia wycieczek fakultatywnych</a
				>
			</button>
		</div>
	</div>
</fieldset>
